function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "m481.007 120h-184.019l48.057-40.622c10.145-8.574 15.962-21.104 15.962-34.378 0-24.813-20.187-45-45-45-19.711 0-36.952 12.617-42.902 31.396l-17.097 53.951-17.097-53.95c-5.952-18.78-23.193-31.397-42.904-31.397-24.813 0-45 20.187-45 45 0 13.273 5.817 25.804 15.961 34.377l48.057 40.623h-184.018v300h180v92.013l45-45 45 45v-92.013h180zm-30 60h-150v-30h150zm-149.304-139.542c1.981-6.255 7.73-10.458 14.304-10.458 8.271 0 15 6.729 15 15 0 4.425-1.941 8.604-5.328 11.466l-39.678 33.539zm-120.696 4.542c0-8.271 6.729-15 15-15 6.573 0 12.322 4.203 14.305 10.459l15.701 49.547-39.679-33.54c-3.386-2.862-5.327-7.041-5.327-11.466zm30 105v30h-150v-30zm-150 240v-180h150v180zm195 34.587-15 15v-272.267l15-12.679 15 12.679v272.267zm45-34.587v-180h150v180z"
}), React.createElement("path", {
  d: "m331.007 330h90v30h-90z"
}));

var SvgPersonalBonus = function SvgPersonalBonus(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512.013 512.013",
    height: 512,
    viewBox: "0 0 512.013 512.013",
    width: 512,
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPersonalBonus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/personal-bonus.bc671b9a.svg";
export { ForwardRef as ReactComponent };